import axios from 'axios';
import type { DateTime } from 'luxon';

export default class SearchService
{
    public static async getSearchResults(query: string, types: string[], values: [string, string][], onlyMine: boolean, allVersions: boolean, pager: Pager)
    {
        return (await axios.post<Pagination<SearchResult>>('admin/search', {
            searchTerm: query,
            types,
            values,
            onlyMine,
            allVersions,
            pager: pager.data()
        })).data;
    }
}

export interface SearchResult
{
    id: number;
    type: string;
    typeName: string;
    dateCreatedUtc: DateTime;
    dateModifiedUtc?: DateTime;
    createdBy: number;
    modifiedBy?: number;
    title: string;
    description: string;
    images: ImageResult[];
    attachments: AttachmentResult[];
    attributes: Record<string, string[]>;
}

export interface ImageResult
{
    id: number;
    url: string;
    name: string;
}

export interface AttachmentResult
{
    id: number;
    name: string;
}

export interface SearchResultType
{
    count: number;
    key: string;
    name: string;
}

export interface SearchResultGroupValue
{
    count: number;
    key: string;
    name: string;
}

export interface SearchResultGroup extends SearchResultGroupValue
{
    values: SearchResultGroupValue[];
}
